<template>
  <v-container
    class="fill-height d-flex justify-center align-center"
  >
    <div class="d-flex flex-column align-center justify-center py-10">
      <v-progress-circular
        indeterminate
        size="75"
      />
      <div class="d-flex justify-center">
        <div class="mt-3">
          {{ $t('logging_out.message') }}
        </div>
      </div>
    </div>
  </v-container>
</template>

<script>
import { AuthApiService } from '@/data/services'

export default {
  name: 'LogoutView',
  created() {
    this.logout()
  },
  methods: {
    async logout() {
      try {
        await AuthApiService.logout()
      } catch (e) {
      } finally {
        this.$store.dispatch(this.$storeActions.AUTH_LOGOUT)
        this.$store.dispatch(this.$storeActions.APP_DESTROY)
        this.$router.push({ name: this.$routeNames.LOGIN })
      }
    }
  }
}
</script>
